import { usePathname } from 'next/navigation'

const useGetItineraryId = () => {
    const pathname = usePathname()
    const itineraryId = pathname.split('/itinerary/')[1]?.split('/')[0] || ''
    return itineraryId
}

export default useGetItineraryId
